// Etat module : source de verite client pour le mode test Care (sandbox).
// Calque sur entityStore.ts. Lu de maniere synchrone par buildHeaders (non-hook)
// pour injecter le header X-Care-Sandbox, et par useSandbox (useSyncExternalStore).

export const LOCALSTORAGE_KEY_SANDBOX = 'care-sandbox'

let active: boolean | undefined

type Listener = () => void
const listeners = new Set<Listener>()

const readStorage = (): boolean => {
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem(LOCALSTORAGE_KEY_SANDBOX) === '1'
}

/** Snapshot client (useSyncExternalStore + buildHeaders). Priorite : etat module > localStorage. */
export const getSandboxSnapshot = (): boolean => active ?? readStorage()

/** Snapshot serveur deterministe (anti-mismatch d'hydratation) : jamais actif cote SSR. */
export const getSandboxServerSnapshot = (): boolean => false

/** Helper synchrone pour buildHeaders. */
export const isSandboxActive = (): boolean => getSandboxSnapshot()

const notify = (): void => {
  listeners.forEach(listener => listener())
}

export const setSandboxActive = (value: boolean): void => {
  active = value
  if (typeof window !== 'undefined') {
    if (value) {
      window.localStorage.setItem(LOCALSTORAGE_KEY_SANDBOX, '1')
    } else {
      window.localStorage.removeItem(LOCALSTORAGE_KEY_SANDBOX)
    }
  }
  notify()
}

export const subscribeSandbox = (callback: Listener): (() => void) => {
  listeners.add(callback)
  return () => {
    listeners.delete(callback)
  }
}
